import React from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";

import { Button } from "app/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "app/components/ui/dialog";
import { getMultiNetworkSelectionData } from "utils/purchase-flow-storage";

interface Props {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  locationState?: any;
}

export const CongratsDialog = ({
  showDialog,
  setShowDialog,
  locationState,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { compatResults } = useOutletContext<{ compatResults: any }>();

  // Use the passed locationState prop if available, otherwise fall back to location.state
  const finalLocationState = locationState || location.state;

  let finalCompatResults = compatResults;

  if (!finalCompatResults || finalCompatResults.length === 0) {
    const storedData = getMultiNetworkSelectionData();
    if (storedData?.phoneType?.phones) {
      finalCompatResults = storedData.phoneType.phones.map((phone) => ({
        deviceSupport: {
          brand: phone.brand,
          model: phone.model,
        },
      }));
    }
  }

  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent className="top-1/2 gap-4 sm:gap-[1.125rem] lg:gap-5 bg-white w-[95%] sm:max-w-[33.5rem] p-4 sm:p-5 lg:p-6">
        <DialogHeader className="flex justify-center items-center p-0 bg-transparent">
          <div className="flex-shrink-0 size-10 sm:size-11 md:size-12 lg:size-[3.125rem] mb-2 sm:mb-3 lg:mb-4">
            <img
              src="/assets/green-tick.svg"
              className="w-full h-auto"
              alt="Tick"
            />
          </div>
          <DialogTitle className="pb-1 text-xl font-bold leading-6 text-black lg:text-2xl md:leading-7 font-mobile">
            Congratulations
          </DialogTitle>
          <DialogDescription className="text-[0.825rem] sm:text-sm font-medium leading-4 sm:leading-5 text-[#3C3C3C] pb-2 md:pb-[0.625rem]">
            Your devices are compatible for VLE Mobile services.
          </DialogDescription>
          <DialogDescription className="text-center max-w-[22.5rem] capitalize text-[0.825rem] sm:text-sm font-bold leading-5 md:leading-[1.375rem] text-black">
            Important: Your phone must be unlocked to work with our service, to
            learn more about unlocking your device{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://vlecdn.b-cdn.net/unlocking-guide.html"
            >
              <span className="text-[#FE4D01] hover:underline">click here</span>
            </a>
          </DialogDescription>
        </DialogHeader>
        <div className="">
          <div className="bg-[#F4F4F4] mb-5 sm:mb-6 lg:mb-[1.685rem]">
            <div className="flex items-center border-b border-[#E5E7EB]">
              <span className="inline-flex justify-center items-center w-8 sm:w-9 lg:w-[2.5625rem] p-2 sm:p-[0.55rem] lg:p-[0.625rem] border-r border-[#E5E7EB] text-[#1D1D1B] text-[0.925rem] sm:text-base font-bold leading-5 sm:leading-6">
                #
              </span>
              <p className="text-[#1D1D1B] text-[0.825rem] sm:text-sm md:text-base font-bold leading-5 sm:leading-6 p-2 sm:p-[0.55rem] lg:p-[0.625rem]">
                Your Device Information
              </p>
            </div>
            {Array.isArray(finalCompatResults) &&
              finalCompatResults?.map((i, index) => {
                return (
                  <div key={index} className="flex items-center">
                    <span className="flex-shrink-0 inline-flex justify-center items-center self-stretch w-8 sm:w-9 lg:w-[2.5625rem] p-2 sm:p-[0.55rem] lg:p-[0.625rem] border-r border-[#E5E7EB] text-[#1D1D1B] text-[0.925rem] sm:text-base font-bold leading-5 sm:leading-6">
                      {index + 1}
                    </span>
                    <p className="text-[#1D1D1B] text-[0.825rem] sm:text-sm md:text-base font-bold leading-5 sm:leading-6 p-2 sm:p-[0.55rem] lg:p-[0.625rem]">
                      {i?.deviceSupport?.brand} {i?.deviceSupport?.model}
                    </p>
                  </div>
                );
              })}
          </div>
          <p className="text-center text-xs sm:text-[0.825rem] lg:text-sm font-medium leading-4 sm:leading-5 text-[#3C3C3C]">
            By clicking “Continue” below, you are confirming your device is
            unlocked
          </p>
        </div>
        <Button
          type="button"
          variant="primary"
          className="h-[2.5rem] sm:h-[3rem] md:h-[3.25rem] lg:h-[3.375rem]"
          onClick={() => {
            setShowDialog(false);
            // console.log("=== CONGRATS DIALOG NAVIGATION DEBUG ===");
            // console.log(
            // 	"Navigating to /checkout with state:",
            // 	finalLocationState,
            // );
            // console.log("getNewLineData:", finalLocationState?.getNewLineData);
            // console.log(
            // 	"getNewLineData.data:",
            // 	finalLocationState?.getNewLineData?.data,
            // );
            // console.log(
            // 	"multiNetworkPlanId:",
            // 	finalLocationState?.getNewLineData?.data?.multinetworkPlanId,
            // );
            // console.log("=========================================");

            navigate("/checkout", {
              state: finalLocationState,
            });
          }}
        >
          Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
};
